import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import styled, { keyframes, css } from 'styled-components';
import { ANIMATION_DURATION, ANIMATION_DELAY } from './constants.js';

const fadeIn = keyframes `
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;
const fadeOut = keyframes `
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(0);
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  align-items: center;
`;
const Content = styled.span `
  min-width: 50%;
`;
const ExtraContent = styled.span(({ theme: { olist: { spacing, components: { tooltip }, }, }, }) => css `
    color: ${tooltip.variations.default.extraContentColor};
    margin-left: ${spacing.inline['1xsmall']};
    max-width: 50%;
  `);
const TooltipImage = styled.img(({ theme: { olist: { spacing, components: { tooltip }, }, }, }) => css `
    width: 20px;
    height: 20px;
    margin-right: ${spacing.inline['1xsmall']};
    border-radius: ${tooltip.radius};
  `);
const StyledContent = styled(TooltipPrimitive.Content)(({ $inverted, theme: { olist: { components: { tooltip }, }, }, }) => css `
    display: flex;
    align-items: center;
    max-width: ${tooltip['max-width']};
    background-color: ${tooltip.variations.default['background-color']};
    color: ${tooltip.variations.default.color};
    border-radius: ${tooltip.radius};
    box-shadow: ${tooltip.shadow};
    font-family: ${tooltip['font-family']};
    font-size: ${tooltip['font-size']};
    line-height: ${tooltip['line-height']};
    padding: ${tooltip.padding};
    border: 1px solid ${tooltip.variations.default['border-color']};
    transform-origin: var(--radix-tooltip-content-transform-origin);
    text-align: center;

    &[data-state='delayed-open'] {
      animation: ${fadeIn} ${ANIMATION_DURATION}ms ease-out forwards;
    }

    &[data-state='closed'] {
      animation: ${fadeOut} ${ANIMATION_DURATION}ms ease-out;
      animation-delay: ${ANIMATION_DELAY}ms;
    }

    svg {
      fill: ${tooltip.variations.default['background-color']};
    }

    ${$inverted &&
    css `
      background-color: ${tooltip.variations.inverted['background-color']};
      color: ${tooltip.variations.inverted.color};
      border-color: ${tooltip.variations.inverted['border-color']};

      svg {
        fill: ${tooltip.variations.inverted['background-color']};

        /* this make sure that only the correct edges of the arrow will
        be painted */
        path:first-child {
          stroke: ${tooltip.variations.inverted['border-color']};
        }
      }

      ${ExtraContent} {
        color: ${tooltip.variations.inverted.extraContentColor};
      }
    `}
  `);

export { Content, ContentWrapper, ExtraContent, StyledContent, TooltipImage };
